import { Modal } from 'antd'
import type { HistoricalDocument } from 'features/Procedure/state/procedure-api.type'
import { LabsPreview } from 'features/Procedure/features/labs/preview'
import styles from './document-preview-dialog.module.scss'

type Props = {
  isOpen: boolean
  document: HistoricalDocument | null
  selectedPatientId: number | null
  selectedEncounterUid: string | null
  onClose: () => void
}

export const DocumentPreviewDialog = ({
  isOpen,
  document,
  selectedPatientId,
  selectedEncounterUid,
  onClose,
}: Props) => {
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      title={null}
      closable={false}
      classNames={{
        wrapper: styles.modalWrapper,
        content: styles.modalContainer,
        body: styles.modalBody,
      }}
      footer={null}
      centered
      destroyOnHidden>
      <LabsPreview
        documentId={document?.id}
        selectedPatientId={selectedPatientId}
        selectedEncounterUid={selectedEncounterUid}
        scrollMode='self'
      />
    </Modal>
  )
}
